module.exports = __webpack_public_path__ + "img/trial1-4.3dfc42f6.png";